export default __webpack_public_path__ + "static/media/like.7a3aad4a.svg";